import firebase from 'firebase';

const config = {
  apiKey: "AIzaSyC_Ml0xiipnVPux1KqQwjGXt-zFvUrnZi0",
  authDomain: "huisarrest-d5ccf.firebaseapp.com",
  databaseURL: "https://huisarrest-d5ccf.firebaseio.com",
  projectId: "huisarrest-d5ccf",
  storageBucket: "huisarrest-d5ccf.appspot.com",
  messagingSenderId: "194776191989",
  appId: "1:194776191989:web:89971a36e3e3d95aba86bc"
};
firebase.initializeApp(config);
export default firebase;
